import React from "react";
import "./Banner.css";
import bannerImage from "../assets/Banner.png";

const Banner = () => {
  return (
    <div className="banner">
      <img src={bannerImage} alt="Banner" />

      <div className="banner-content">
        <h1>AAPS Placements</h1>
        <h2>Build Your Career in IT</h2>
        <p>Learn | Train | Get Placed</p>
      </div>
    </div>
  );
};

export default Banner;
